// React Redux
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Components
import ModalWrapper from "../../../ModalWrapper";

// Libs
import { ButtonSpocket } from "shared_components";
import { default as Loadable } from "../../../commonLoadable";

// Icons
import warningIcon from "../../../../../assets/warning-icon.svg";

// Actions
import { downgradePlan } from "../../../../../actions/settings";
import { handleUpgradeRequest } from "../../../../../actions/upgrade.js";

// Style
import "../style.css";

class DowngradePlanPromotionalModal extends Component {
  getPlanPrice() {
    const selectedPlan = this.getPlan();

    return selectedPlan.price;
  }

  getPlan() {
    return this.props.allPlans.find(
      plan => plan.name === "Promotional" && plan.annual === false
    );
  }

  upgradeToTier() {
    const { tracker, eventId } = this.props;

    if (this.props.allPlans) {
      const selectedPlan = this.getPlan();

      this.props.handleUpgradeRequest(
        selectedPlan.id,
        selectedPlan.name,
        { ...tracker, event_id: eventId },
        selectedPlan
      );
    }
  }

  render() {
    return (
      <ModalWrapper size="Downgrade_Plan_Modal">
        <Loadable active={this.props.isUpgrading || !this.props.allPlans}>
          <ModalWrapper.Header>
            <img
              src={warningIcon}
              alt="Warning icon"
              style={{ marginRight: "15px" }}
            />
            <strong>Claim this one time offer</strong>
          </ModalWrapper.Header>
          <ModalWrapper.Body style={{ display: "inline-block" }}>
            <div style={{ marginBottom: "10px" }}>
              We get it. Life is expensive.
            </div>
            <div>
              Claim this one time offer! Get Spocket Pro for{" "}
              <strong>
                {this.props.allPlans && this.getPlanPrice()} for 3 months!
              </strong>
            </div>
          </ModalWrapper.Body>
          <ModalWrapper.Footer>
            {this.renderGetThisOfferButton()}
          </ModalWrapper.Footer>
        </Loadable>
      </ModalWrapper>
    );
  }

  /**
   * Render Get this offer Button
   * @return {ReactElement} <ButtonSpocket />
   */
  renderGetThisOfferButton() {
    return (
      <ButtonSpocket
        customButton={{
          fontSize: "12px",
          fontWeight: "600",
          height: "36px"
        }}
        bsStyle="success"
        onClick={() => {
          this.upgradeToTier();
        }}
      >
        Get this offer
      </ButtonSpocket>
    );
  }
}

function mapStateToProps(state) {
  return {
    isUpgrading:
      state.store.planCharges.isFetching ||
      state.store.subscriptions.isFetching,
    storeId: state.settings.storeId,
    tracker: state.sharedComponents.tracker,
    eventId: state.eventTracker.eventId,
    allPlans: state.store.plans.allPlans
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ downgradePlan, handleUpgradeRequest }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DowngradePlanPromotionalModal);



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/DowngradePlanModal/DowngradePlanPromotionalModal/DowngradePlanPromotionalModal.js